export const EDITOR_STARTED = 'load';
export const LOGIN = 'login';
export const WS_CONNECTED = 'init';
export const DOCUMENT_READY = 'ready';
export const DESTROYED = 'destroyed';
export const LOADER_SHOWN = 'loader-shown';
